var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextfieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5C2 6.33 2.67 7 3.5 7H7V17.5C7 18.33 7.67 19 8.5 19C9.33 19 10 18.33 10 17.5V7H13.5C14.33 7 15 6.33 15 5.5C15 4.67 14.33 4 13.5 4H3.5C2.67 4 2 4.67 2 5.5ZM19.5 9H13.5C12.67 9 12 9.67 12 10.5C12 11.33 12.67 12 13.5 12H15V17.5C15 18.33 15.67 19 16.5 19C17.33 19 18 18.33 18 17.5V12H19.5C20.33 12 21 11.33 21 10.5C21 9.67 20.33 9 19.5 9Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextfieldIcon);
export default __webpack_public_path__ + "static/media/TextfieldIcon.c8db7f93b106ef18ff1473974de3c456.svg";
export { ForwardRef as ReactComponent };